import {useMutation, useQueryClient} from '@github-ui/react-query'
import {fetchCAPI} from '../utils/fetch-capi'
import {agentTaskQueryKey} from './use-task'

interface UseArchiveTaskArgs {
  taskId?: string
  repoOwner?: string
  repoName?: string
}

export function useArchiveTask({taskId, repoOwner, repoName}: UseArchiveTaskArgs) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['archiveTask', repoOwner, repoName, taskId],
    mutationFn: async () => {
      const response = await fetchCAPI({
        path: `/agents/repos/${repoOwner}/${repoName}/tasks/${taskId}/archive`,
        method: 'POST',
      })
      return response
    },
    onSuccess: () => {
      // Invalidate task/tasks queries to refetch the task list
      const taskQueryKey = agentTaskQueryKey(repoOwner, repoName, taskId)
      queryClient.invalidateQueries({queryKey: taskQueryKey})
      queryClient.invalidateQueries({queryKey: ['repo-tasks', repoOwner, repoName]})
    },
  })
}
